import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import Navr from "../Navbar/Navr";
import Footer from "./Footer";
import img1 from "../Ecomphotos/g1.jpg";
import img2 from "../Ecomphotos/gg7.jpg";
import img3 from "../Ecomphotos/gg9.jpg";
import img4 from "../Ecomphotos/gg2.jpg";
import img5 from "../Ecomphotos/g5.jpg";
import img6 from "../Ecomphotos/g6.jpg";
import img7 from "../Ecomphotos/lighting.jpg";
import img8 from "../Ecomphotos/gg8.jpg";
import img9 from "../Ecomphotos/g7.jpg";
const galleryData = [
  { id: 1, category: "concert", src: img1, title: "Open Air Concert" },
  { id: 2, category: "wedding", src: img2, title: "Royal Wedding Entry" },
  { id: 3, category: "lights", src: img3, title: "Laser Show" },
  { id: 4, category: "setup", src: img4, title: "Truss Setup" },
  { id: 5, category: "concert", src: img5, title: "Crowd Energy" },
  { id: 6, category: "wedding", src: img6, title: "Sangeet Night" },
  { id: 7, category: "lights", src: img7, title: "Sharpy Beam Effects" },
  { id: 8, category: "setup", src: img8, title: "DJ Console View" },
  { id: 9, category: "concert", src: img9, title: "Live Performance" },
];

function Gallery() {
  const [filter, setFilter] = useState("all");
  const [selectedImg, setSelectedImg] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Filter Logic
  const filteredImages =
    filter === "all"
      ? galleryData
      : galleryData.filter((img) => img.category === filter);

  return (
    <>
      <Navr />
      <div className="gallery-page">
        <header className="contact-hero">
          <div className="container">
            <h1 className="hero-title text-white">VISUAL EXPERIENCE</h1>
            <p className="lead text-light letter-spacing-2">
              Witness the Vibe of Tillu Events
            </p>
          </div>
        </header>

        <section className="container py-4">
          <div className="d-flex justify-content-center flex-wrap mb-4">
            <button
              className={`filter-btn ${filter === "all" ? "active" : ""}`}
              onClick={() => setFilter("all")}
            >
              All
            </button>
            <button
              className={`filter-btn ${filter === "concert" ? "active" : ""}`}
              onClick={() => setFilter("concert")}
            >
              Concerts
            </button>
            <button
              className={`filter-btn ${filter === "wedding" ? "active" : ""}`}
              onClick={() => setFilter("wedding")}
            >
              Weddings
            </button>
            <button
              className={`filter-btn ${filter === "lights" ? "active" : ""}`}
              onClick={() => setFilter("lights")}
            >
              Lighting
            </button>
            <button
              className={`filter-btn ${filter === "setup" ? "active" : ""}`}
              onClick={() => setFilter("setup")}
            >
              Tech Setup
            </button>
          </div>

          <div className="row g-3">
            {filteredImages.map((img) => (
              <div
                key={img.id}
                className="col-md-4 col-sm-6 animate__animated animate__fadeIn"
              >
                <div
                  className="gallery-card"
                  onClick={() => setSelectedImg(img.src)}
                >
                  <img src={img.src} alt={img.title} />
                  <div className="gallery-overlay">
                    <span className="overlay-icon">🔍</span>
                    <span className="overlay-text">{img.title}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {filteredImages.length === 0 && (
            <p className="text-center text-muted mt-5">
              No images found in this category.
            </p>
          )}
        </section>

        <section className="py-5 bg-dark">
          <div className="container">
            <h2 className="section-title text-center mb-5">Live In Action</h2>
            <div className="row g-4">
              <div className="col-md-6">
                <div className="video-card">
                  <img
                    src="https://images.unsplash.com/photo-1429962714451-bb934ecdc4ec?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
                    className="img-fluid w-100"
                    style={{ height: "350px", objectFit: "cover" }}
                    alt="Video Thumbnail"
                  />
                  <div className="play-btn">▶</div>
                </div>
                <h4 className="text-white mt-3">Grand Symphony Event 2024</h4>
              </div>
              <div className="col-md-6">
                <div className="video-card">
                  <img
                    src="https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
                    className="img-fluid w-100"
                    style={{ height: "350px", objectFit: "cover" }}
                    alt="Video Thumbnail"
                  />
                  <div className="play-btn">▶</div>
                </div>
                <h4 className="text-white mt-3">Wedding Sangeet Highlights</h4>
              </div>
            </div>
          </div>
        </section>

        <section className="py-5 text-center" style={{ background: "#050505" }}>
          <div className="container">
            <h2 className="mb-4 fw-bold text-white">Like What You See?</h2>
            <Link to="/contact" className="btn-neon-lg">
              Book Your Event
            </Link>
          </div>
        </section>

        {selectedImg && (
          <div className="image-modal" onClick={() => setSelectedImg(null)}>
            <span className="close-modal">&times;</span>
            <img
              src={selectedImg}
              alt="Full View"
              className="modal-content-img"
              onClick={(e) => e.stopPropagation()}
            />
          </div>
        )}
      </div>
      <Footer />
    </>
  );
}

export default Gallery;
